export default __webpack_public_path__ + "assets/images/1a9abbe688ab08eb8a21d16f165f703b.png";